import api from "./api";

export const getsTerapiaPlanResumenView = async (filters) => {
    const response = await api.get('/TerapiaPlan/GetsTerapiaPlanResumenView?'
            + 'idFilial=' + (filters.idFilial == null ? 0 : filters.idFilial)
            + '&member=' + (filters.member == null ? "" : filters.member)
            + '&therapist=' + (filters.therapist == null ? "" : filters.therapist)
            + '&idEstadoVigencia=' + (filters.idEstadoVigencia == null ? "" : filters.idEstadoVigencia)
            + '&idEstado=' + (filters.idEstado == null ? "" : filters.idEstado)
        );

    return response.data.data;
}

export const annulTerapiaPlan = (idTerapiaPlan) =>
    api.post("/TerapiaPlan/AnnulTerapiaPlan?idTerapiaPlan=" + idTerapiaPlan);

export const activeTerapiaPlan = (idTerapiaPlan) =>
    api.post("/TerapiaPlan/ActiveTerapiaPlan?idTerapiaPlan=" + idTerapiaPlan);

export const addUpdateTerapiaPlanWithDetails = (dataPost) =>
    api.post("/TerapiaPlan/AddUpdateTerapiaPlanWithDetails", dataPost);
